import { useEffect, useState } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import { useLoggedInUser } from "../../../../utils/logged-in-user-provider";

import { LoggedInUser } from "./components/loggedin-user-view";
import { LoggedOutUser } from "./components/loggedout-user-view";
import { LoadingSpinner } from "./components/spinner";

const analyticsLabels = {
    "JoinSiteUserDropdown.logOut": "Log out",
    "JoinSiteUserDropdown.logIn": "Sign in",
    "JoinSiteUserDropdown.joinTeam": "Find my team",
    "JoinSiteUserDropdown.profile": "Profile",
    "JoinSiteUserDropdown.switchAccount": "Switch Account",
    "JoinSiteUserDropdown.licenses": "Licenses"
} as const;

const NEXT_PUBLIC_API_MAC_URL = process.env["NEXT_PUBLIC_API_MAC_URL"];
const NEXT_PUBLIC_IDENTITY_BASE_URL =
    process.env["NEXT_PUBLIC_IDENTITY_BASE_URL"];
const NEXT_PUBLIC_API_PRIVATE_BASE_URL =
    process.env["NEXT_PUBLIC_API_PRIVATE_BASE_URL"];

export const GlobalNavUserProfile = () => {
    const [isLoading, setIsLoading] = useState(true);
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const userInfo = useLoggedInUser();
    useEffect(() => {
        userInfo.requestInProgress ? setIsLoading(true) : setIsLoading(false);
    }, [userInfo]);

    const onManageLicensesClick = () => {
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.manage.licenses",
            label: analyticsLabels["JoinSiteUserDropdown.licenses"]
        }).fire();
        window.location.assign(NEXT_PUBLIC_API_MAC_URL as string);
    };

    const getManageProfileUrl = (userEmail: string) => {
        const applicationParam = encodeURIComponent("wac");
        const continueUrlParam = encodeURIComponent(
            `${NEXT_PUBLIC_IDENTITY_BASE_URL}/manage-profile`
        );
        const loginHintParam = encodeURIComponent(userEmail);

        return `${NEXT_PUBLIC_IDENTITY_BASE_URL}/login?application=${applicationParam}&continue=${continueUrlParam}&login_hint=${loginHintParam}`;
    };
    const onManageProfileClick = () => {
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.manage.profile",
            label: analyticsLabels["JoinSiteUserDropdown.profile"]
        }).fire();

        window.location.assign(getManageProfileUrl(userInfo.email));
    };

    const getLogoutUrl = () => {
        const continueUrl = window.location.href;
        return `${NEXT_PUBLIC_IDENTITY_BASE_URL}/logout?continue=${encodeURIComponent(
            continueUrl
        )}`;
    };
    const onLogOutClick = () => {
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.logout",
            label: analyticsLabels["JoinSiteUserDropdown.logOut"]
        }).fire();

        window.location.assign(getLogoutUrl());
    };

    const onLogInClick = () => {
        const baseUrl = NEXT_PUBLIC_IDENTITY_BASE_URL;
        const stargateBaseUrl = NEXT_PUBLIC_API_PRIVATE_BASE_URL;
        const continueUrl = stargateBaseUrl + "/start/authredirect";

        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.login",
            label: analyticsLabels["JoinSiteUserDropdown.logIn"]
        }).fire();

        window.location.assign(
            `${baseUrl}/login?continue=${encodeURIComponent(continueUrl)}`
        );
    };

    const getSwitchAccountURL = (continueUrlParam?: string) => {
        const continueUrl = continueUrlParam
            ? continueUrlParam
            : window.location.href;
        return `${NEXT_PUBLIC_IDENTITY_BASE_URL}/login/select-account?continue=${encodeURIComponent(
            continueUrl
        )}`;
    };
    const onSwitchAccountClick = () => {
        createAnalyticsEvent({
            action: "clicked",
            name: "bxp.globalnavdropdown.click.switchAccount",
            label: analyticsLabels["JoinSiteUserDropdown.switchAccount"]
        }).fire();

        window.location.assign(getSwitchAccountURL());
    };

    if (isLoading) {
        return LoadingSpinner;
    }

    return (
        <div>
            {userInfo.isUserLoggedIn ? (
                <LoggedInUser
                    userInfo={{
                        displayName: userInfo.name,
                        email: userInfo.email,
                        avatar: userInfo.picture
                    }}
                    onSwitchAccountClick={onSwitchAccountClick}
                    onManageProfileClick={onManageProfileClick}
                    onManageLicensesClick={onManageLicensesClick}
                    onLogOutClick={onLogOutClick}
                />
            ) : (
                <LoggedOutUser onLogInClick={onLogInClick} />
            )}
        </div>
    );
};
